window._ = require('lodash');
import Headroom from "headroom.js";
window.NProgress = require("nprogress");
// require('cookieconsent/src/cookieconsent');

NProgress.start();

/* global msjCookies */
window.onload = function() {
    NProgress.done();
    // window.cookieconsent.initialise({
    //     "palette": {
    //         "popup": {
    //             "background": "#000000",
    //             "text": "#999999"
    //         },
    //         "button": {
    //             "background": "#111111",
    //             "text": "#ffffff"
    //         }
    //     },
    //     "theme": "edgeless",
    //     "position": "bottom-right",
    //     "content": {
    //         "message": msjCookies.message,
    //         "dismiss": msjCookies.dismiss,
    //         "link": msjCookies.link,
    //         "href": msjCookies.href
    //     }
    // });
};

/** Axios **/
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.validateStatus = function (status) {
    return status >= 200 && status < 300 || status === 422; // default
};
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

const ctrMenus = document.querySelector(".ctr-menus");
if (ctrMenus && !ctrMenus.classList.contains("checkout-finalizacion")) {
    let headroom  = new Headroom(ctrMenus, {
        "offset": 221,
        "tolerance": 5
    });
    headroom.init();
}


window.popAbierto = false;

require("./modules/menu");
require("./modules/buscador");
require("./modules/autentificacion");
require("./modules/cesta");
require("./modules/boletin");
require("./modules/popup");

import { Splash } from './modules/splash';
let splash = new Splash();

if (!window.popAbierto) {
    splash.abrir();
}
